import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';
import { getBadgeAchievementLeaderboard } from '../api/leaderboard';

export interface IDataBadgeAchievementList {
  rank: number;
  learner_id: number;
  user_email?: string;
  first_name: string;
  last_name: string;
  segment?: string;
  total_points: number;
  training_status: number;
  report_count?: number;
  average_response_time_minutes?: string;
}

export interface IGroupBadgeAchievementList {
  rank: number;
  group: string;
  average_points: number;
  has_group: boolean;
  training_status: number;
  report_count?: number;
}

export interface IPagination {
  "total_items": number,
  "total_page": number,
  "offset": number,
  "limit": number,
  "has_more": boolean
}

export interface IDataBadgeAchievement {
  rankings: {
    data:IDataBadgeAchievementList[],
    pagination:IPagination
  };
  groups: {
    data: IGroupBadgeAchievementList[],
    pagination:IPagination
  };
}

export interface GetAssignedLearningListObjectState {
  dataBadgeAchievement: IDataBadgeAchievement;
  isLoading: boolean;
  error?: string;
}

const initialState: GetAssignedLearningListObjectState = {
  dataBadgeAchievement: {
    rankings: {
      data:[],
      pagination:{
        total_items: 0,
        total_page: 0,
        offset: 1,
        limit: 1,
        has_more: false
      }
    },
    groups: {
      data:[],
      pagination:{
        total_items: 0,
        total_page: 0,
        offset: 1,
        limit: 1,
        has_more: false
      }
    },
  },
  isLoading: false,
  error: undefined
};

export const getBadgeAchievementListEvents = createAsyncThunk(
  'getBadgeAchievementListEventLeaderboard',
  async (params: any) => {
    const response = await getBadgeAchievementLeaderboard(params);
    return response ? response : initialState;
  }
);

export const getBadgeAchievementListSlice = createSlice({
  name: 'getBadgeAchievementListEvents',
  initialState,
  reducers: {
    removeBadgeAchievement: (state) => {
      state.isLoading = false;
      state.dataBadgeAchievement = initialState.dataBadgeAchievement;
      state.error = undefined;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getBadgeAchievementListEvents.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      getBadgeAchievementListEvents.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.dataBadgeAchievement = action.payload;
        state.error = undefined;
      }
    );

    builder.addCase(getBadgeAchievementListEvents.rejected, (state, action) => {
      state.isLoading = false;
      state.dataBadgeAchievement = initialState.dataBadgeAchievement;
      state.error = action.payload as string;
    });
  }
});

export const { removeBadgeAchievement  } = getBadgeAchievementListSlice.actions;

export const getBadgeAchievementListEventsDataSelector = (state: RootState) =>
  state.getBadgeAchievementListEvents;
export default getBadgeAchievementListSlice.reducer;
